import React, {useState, useRef, useEffect} from "react"
import './select-custom.scss'

export default function SelectCustom({json, dependencies, onFieldChange})
{           
    const field = useRef()
    const display = useRef()
    const list = useRef()
    const [value, setValue] = useState()
    const [options, setOptions] = useState([])   
    const [placeholder, setPlaceholder] = useState('')
    const [empty, setEmpty] = useState(true)
    const [classes, setClasses] = useState('list')
    const [mainClasses, setMainClasses] = useState('json-input select-custom field_'+json.key)

    const updateList = (index) =>
    {                
        const childs = list.current.childNodes
        
        for (var i = 0; i < childs.length; i++) 
        {
            childs[i].classList.remove('current')
            if(childs[i].dataset.index === index) childs[i].classList.add('current')
        }
    }

    const updateValue = (e) =>
    {
        if(!e.target) return          
        const val = e.target.dataset.value
        const name = e.target.dataset.name
        const index = e.target.dataset.index
        if(!val || !name) return        
        setValue(val)
        display.current.innerHTML = name
        setEmpty(false)
        setClasses('list')
        setMainClasses('json-input select-custom field_'+json.key)
        updateList(index)
        if(dependencies) dependencies(json.key, val)
        if(onFieldChange) onFieldChange(json.key, val)
    }

    const clean = () =>
    {
        setValue('')
        display.current.innerHTML = placeholder
        setEmpty(true)
        updateList(0)
        setClasses('list')
        setMainClasses('json-input select-custom field_'+json.key)
    }

    const closeOptions = () =>
    {
        setClasses('list')   
        setMainClasses('json-input select-custom field_'+json.key)
    }

    const showOptions = () =>
    {
        setClasses('list show')
        setMainClasses('json-input select-custom open field_'+json.key)
    }

    useEffect(()=>
    {
        if(!json.options) return null
        const opts = json.options

        display.current.innerHTML = opts[0][1]

        setPlaceholder(opts[0][1])
        
        if(opts[0][0] === '') opts.shift()

        setOptions(opts)

    },[])

    return (
        <div className={mainClasses}>
            {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} /> }
            <input className={'input_'+json.key} type="hidden" name={json.key} ref={field} value={value} />
            <div className={"display"+(empty === true ? " empty" : "") }>
                <div className="txt" ref={display} onClick={showOptions}></div>
                {empty && <span onClick={showOptions}><i class="fas fa-chevron-circle-down"></i></span>}
                {!empty && <span onClick={clean}><i class="far fa-times-circle"></i></span>}
            </div>
            <div className={classes}>
                <div className="options" ref={list}>
                    <div className="option first" data-name={''} data-value={''} onClick={closeOptions}>...</div>
                    {
                        options.map((option, index) =>
                        {                                        
                            return(<div key={'key_'+index} data-index={index} className="option" data-name={option[1]} data-value={option[0]} onClick={updateValue}>{option[1]}</div>)
                        })                
                    }   
                </div>
            </div>
        </div>   
    ) 
}